import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Loader from '../../../../Shared/Loader'
import Alert from '../../../../Shared/Alert'
import { adminGetComments, postSubscriptionComment } from '../../../../../api'
import PropTypes from 'prop-types'
import { Col, Row } from '../../../../Shared/Grid'
import TextArea from '../../../../Shared/Form/TextArea'
import Button from '../../../../Shared/Form/Button'
import dayjs from 'dayjs'

class OrderComments extends Component {

  constructor (props) {
    super(props)
    this.state = {
      comments: [],
      loading: false,
      error: null,
      newComment: ''
    }
    this.abortController = null
  }

  componentDidMount () {
    this.loadComments()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.orderId !== prevProps.orderId) {
      this.loadComments()
    }
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  onInputChange (event, name) {
    let state = {}
    state[name] = event.target.value
    this.setState(state)
  }

  loadComments () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminGetComments(this.props.orderId, this.abortController).fetchPromise.then((response) => {
        this.setState({ loading: false, comments: response })
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed to load comments' })
      })
    })
  }

  addNewComment () {
    this.setState({ loading: true }, () => {
      postSubscriptionComment(this.props.orderId, this.state.newComment).fetchPromise.then((response) => {
        this.state.comments.unshift(response)
        this.setState({ comments: this.state.comments, loading: false, newComment: '' })
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed to add new comment' })
      })
    })
  }

  createCommentRow (comment) {
    return (
      <div className="order-comment" key={comment.id}>
        <div>{comment.comment}</div>
        <div className={'order-comment-footer'}>
          <span>{comment.userCode}</span>
          <span>{comment.createdAt ? dayjs(comment.createdAt).locale(this.props.i18n.language).format('L LT') : '-'}</span>
        </div>
      </div>
    )
  }

  render () {
    const { t } = this.props
    return (
      <Row style={{ position: 'relative' }}>
        <Col xs={12}>
          <h3>{t('COMMENTS')}</h3>
        </Col>
        {
          (this.state.loading || this.state.error) && <Col xs={12}>
            {this.state.loading && <Loader size={32}/>}
            {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
          </Col>
        }
        <Col xs={12}>
          {this.state.comments.length > 0 ?
            this.state.comments.map(comment => this.createCommentRow(comment))
            : <Alert type={'info'}>No comments found</Alert>}
        </Col>
        <Col xs={12}>
          <TextArea onChange={(e) => {this.onInputChange(e, 'newComment')}} placeholder={t('ADD_NEW_COMMENT')}
                    value={this.state.newComment}/>
          <Button disabled={this.state.newComment === '' || this.state.loading}
                  align={'right'}
                  style={{ position: 'relative' }}
                  onClick={() => this.addNewComment(this.state.newComment)}> {this.state.loading ?
            <Loader size={32}/> : null}{t('ADD')}</Button>
        </Col>
      </Row>
    )
  }
}

OrderComments.propTypes = {
  orderId: PropTypes.number.isRequired
}

export default withTranslation()(OrderComments)
